/* eslint-disable max-len */
import { IIconProps } from 'src/interfaces/IconProps';

const MuteIndicatorIcon = ({
  width = 4,
  height = 5,
  color = '#fff',
  ...props
}: IIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 4 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.2 0.0999966C0.420914 -0.0656889 0.734314 -0.0209174 0.899999 0.199996L2 1.66666L3.1 0.199996C3.26569 -0.0209174 3.57909 -0.0656889 3.8 0.0999966C4.02091 0.265682 4.06568 0.579082 3.9 0.799996L2.625 2.5L3.9 4.2C4.06568 4.42091 4.02091 4.73431 3.8 4.9C3.57909 5.06568 3.26569 5.02091 3.1 4.8L2 3.33333L0.899999 4.8C0.734314 5.02091 0.420914 5.06568 0.2 4.9C-0.0209143 4.73431 -0.0656862 4.42091 0.0999992 4.2L1.375 2.5L0.0999992 0.799996C-0.0656862 0.579082 -0.0209143 0.265682 0.2 0.0999966Z"
      fill={color}
    />
  </svg>
);

export default MuteIndicatorIcon;
